webpackJsonp([194115596745226],{

/***/ 1618:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/luke-fagg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-luke-fagg-5107da2ff940f9300f57.js